// extracted by css-extract-rspack-plugin
export default {"tool":"GKOAEzaiJbQQ71td","description":"fLi67lqwCkQ_bJ8Y"};